@if (userSession$ | async) {
  <li class="bc-header-nav-item">
    <em class="bc-icon bc-sm">user</em>
    <div class="bc-header-nav-item-text">{{ (userSession$ | async).user }}</div>
  </li>
}
